import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { partnerApi } from "../../../../../../services/Api/Partner/partnerApi";
import { PartnerActionTypes, PartnerApi } from "../../../../../../services/Api/Partner/partnerTypes";
import PartnerCard from "./components/PartnerCard";

const PartnerDashboardPage = () => {
	const [partners, setPartners] = useState<PartnerApi[] | undefined>(undefined);
	const { addFlash } = useFlash();
	const { t } = useTranslation("admin");
	const dispatch = useDispatch();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleInit();
	}, []);

	const handleInit = async () => {
		handleChangeTabTitle(
			`${t("modules.partner.field.your_partners.title")} | ${t("modules.partner.field.partner_panel.title")}`
		);
		dispatch({
			type: PartnerActionTypes.CLEAR,
		});
		await fetchPartners();
	};

	const fetchPartners = async () => {
		try {
			const res = await partnerApi.getPartners({ include: "parent" });
			setPartners(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!partners) {
		return <LoadingContainer />;
	}

	return (
		<div className={"content"}>
			<Header title={t("modules.partner.field.your_partners.title")} />
			<div className={"row"}>
				{partners.map((partner) => {
					return <PartnerCard partner={partner} key={partner.id} />;
				})}
			</div>
		</div>
	);
};
export default PartnerDashboardPage;
